var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 206,
    viewBox: "0 0 381 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_950",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 381,
    height: 206
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.459961 0.568359H380.46V205.412H0.459961V0.568359Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_950)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7048 109.042L190.58 144.589L292.45 109.042V170.594C292.45 189.824 246.84 205.412 190.58 205.412C134.314 205.412 88.7048 189.824 88.7048 170.594V109.042ZM190.58 0.568359L380.694 66.9017L352.575 76.7142V131.209L353.371 131.454C357.59 133.24 360.554 137.417 360.554 142.282C360.554 145.527 359.236 148.464 357.106 150.594L356.918 150.745L363.486 189.261H334.101L340.668 150.745L340.481 150.594C338.356 148.464 337.043 145.527 337.043 142.282C337.043 137.417 340.007 133.24 344.22 131.454L345.012 131.209V79.3548L190.58 133.235L0.459961 66.9017L190.58 0.568359Z",
    fill: "#F0573E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.0b014f65f481a5f5608d1cadb3634abe.svg";
export { ForwardRef as ReactComponent };